import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { MasterBoxComponent } from '../components/master-box/master-box.component';

import { AgGridAngular } from 'ag-grid-angular';
import { FeedComponent } from '../components/feed/feed.component';
import { FilterComponent } from '../components/filter/filter.component';
import { HeaderComponent } from '../components/header/header.component';
import { HierarchyViewComponent } from '../components/hierarchy-view/hierarchy-view.component';
import { HierarchyComponent } from '../components/hierarchy/hierarchy.component';
import { ATextAreaComponent } from '../components/input/a-textarea/a-textarea.component';
import { MasterDropdownComponent } from '../components/master-dropdown/master-dropdown.component';
import { PaginationComponent } from '../components/pagination/pagination.component';
import { PdCardComponent } from '../components/pd-card/pd-card.component';
import { PrintComponent } from '../components/print/print.component';
import { SearchComponent } from '../components/search/search.component';
import { TableHeaderComponent } from '../components/table-header/table-header.component';
import { UserMergeComponent } from '../components/user-merge/user-merge.component';
import { CondolenceComponent } from '../pages/insta/condolence/condolence.component';
import { EventComponent } from '../pages/insta/event/event.component';
import { JobComponent } from '../pages/insta/job/job.component';
import { MarriageComponent } from '../pages/insta/marriage/marriage.component';
import { ShopComponent } from '../pages/insta/shop/shop.component';
import { CircleComponent } from '../pages/profile/circle/circle.component';
import { NodeComponent } from '../pages/profile/node/node.component';
import { AddressComponent } from '../pages/user/address/address.component';
import { UserEditComponent } from '../pages/user/user-edit/user-edit.component';
import { UserViewPage } from '../pages/user/user-view/user-view.page';
import { Swim2Component } from '../pages/vansh/swim2/swim2.component';
import { DateShortPipe } from '../pipes/date-short.pipe';
import { DigitPipe } from '../pipes/digit-short.pipe';
import { EncryptionPipe } from '../pipes/encryption.pipe';
import { FancyDateOnlyPipe } from '../pipes/fancy-date-only.pipe';
import { FancyDatePipe } from '../pipes/fancy-date.pipe';
import { FancyFullDatePipe } from '../pipes/fancy-full-date.pipe';
import { FancyMonthYearPipe } from '../pipes/fancy-month-year.pipe';
import { FancyTimeOnlyPipe } from '../pipes/fancy-time-only.pipe';
import { FancyYearOnlyPipe } from '../pipes/fancy-year-only.pipe';
import { InWordsPipe } from '../pipes/in-word.pipe';
import { MiliDateDiffPipe } from '../pipes/mili-date-diff';
import { MiliDateFancyPipe } from '../pipes/mili-date-fancy';
import { MiliDateTimePipe } from '../pipes/mili-date-time';
import { MiliToTimePipe } from '../pipes/mili-to-time';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { SimpleDatePipe } from '../pipes/simple-date.pipe';
import { PhoneInputComponent } from '../components/phone-input/phone-input.component';
import { OtpVerificationComponent } from '../components/otp-verification/otp-verification.component';
import { SortingPipe } from '../pipes/sorting.pipe';
import { SplitDateOnlyPipe } from '../pipes/split-date-only.pipe';
import { TwoDigitDecimalPipe } from '../pipes/two-digit-decimal.pipe';
import { TwoDigitPipe } from '../pipes/two-digit.pipe';
import { YesNoPipe } from '../pipes/yes-no.pipe';
import { AttachmentDisplayComponent } from './../components/attachment/attachment-display/attachment-display.component';
import { AInputComponent } from './../components/input/a-input/a-input.component';
import { ASelectComponent } from './../components/input/a-select/a-select.component';
import { DateComponent } from './../components/input/date/date.component';
import { AgePipe } from './../pipes/age.pipe';
import { DateModelComponent } from '../components/date-model/date-model.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { BhawanComponent } from '../pages/insta/bhawan/bhawan.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { InfoComponent } from '../pages/insta/info/info.component';
import { LinebreaksPipe } from '../pipes/linebreak.pipe';
import { DesignationLocationComponent } from '../components/designation-location/designation-location.component';
import { UserListCardComponent } from '../components/user-list-card/user-list-card.component';
import { TranslatePipe } from '../pipes/translate.pipe';
import { CommitteeMemberListComponent } from '../pages/committee-member-list/committee-member-list.component';
import { DonationListComponent } from '../pages/community/donation-list/donation-list.component';
import { RuleBoxComponent } from '../pages/election/rule-box/rule-box.component';
import { ElectionListPage } from '../pages/election/election-list/election-list.page';
import { QRCodeModule } from 'angularx-qrcode';
import { DonationCardComponent } from '../pages/community/donation/donation-card/donation-card.component';
import { PaymentDetailsComponent } from '../pages/community/donation/payment/payment-details/payment-details.component';
import { PaymentEditComponent } from '../pages/community/donation/payment/payment-edit/payment-edit.component';
import { DonationCardDetailsComponent } from '../pages/community/donation/donation-card-details/donation-card-details.component';
import { Slide1Component } from '../components/slides/slide1/slide1.component';
import { Slide2Component } from '../components/slides/slide2/slide2.component';
import { Slide3Component } from '../components/slides/slide3/slide3.component';
import { Slide4Component } from '../components/slides/slide4/slide4.component';
import { AddRelativeComponent } from '../components/add-relative/add-relative.component';
import { Slide5Component } from '../components/slides/slide5/slide5.component';
import { CommunityRequestComponent } from '../components/slides/community-request/community-request.component';
import { PincodeComponent } from '../components/pincode/pincode.component';
import { ApproversComponent } from '../components/approvers/approvers.component';
import { HeroesComponent } from '../components/heroes/heroes.component';
import { VersionUpdateComponent } from '../components/version-update/version-update.component';
import { MigrateCommunityComponent } from '../components/migrate-community/migrate-community.component';

@NgModule({
        declarations: [
                LinebreaksPipe,
                DateShortPipe,
                FancyDateOnlyPipe,
                FancyFullDatePipe,
                SafeHtmlPipe,
                FancyYearOnlyPipe,
                FancyDatePipe,
                SortingPipe,
                FancyTimeOnlyPipe,
                FancyMonthYearPipe,
                SplitDateOnlyPipe,
                MiliToTimePipe,
                TwoDigitPipe,
                TwoDigitDecimalPipe,
                EncryptionPipe,
                DigitPipe,
                MiliDateTimePipe,
                MiliDateFancyPipe,
                MiliDateDiffPipe,
                TranslatePipe,
                InWordsPipe,
                DateComponent,
                AInputComponent,
                ATextAreaComponent,
                ASelectComponent,
                AttachmentDisplayComponent,
                SimpleDatePipe,
                AgePipe,
                PrintComponent,
                SimpleDatePipe,
                SearchComponent,
                FilterComponent,
                HeaderComponent,
                HierarchyViewComponent,
                HierarchyComponent,
                YesNoPipe,
                CircleComponent,
                NodeComponent,
                UserViewPage,
                AddressComponent,
                Swim2Component,
                MasterDropdownComponent,
                PaginationComponent,
                FeedComponent,
                PdCardComponent,
                MasterBoxComponent,
                CondolenceComponent,
                MarriageComponent,
                JobComponent,
                ShopComponent,
                EventComponent,
                TableHeaderComponent,
                UserMergeComponent,
                UserEditComponent,
                DateModelComponent,
                BhawanComponent,
                LoaderComponent,
                InfoComponent,
                DesignationLocationComponent,
                UserListCardComponent,
                CommitteeMemberListComponent,
                DonationListComponent,
                RuleBoxComponent,
                ElectionListPage,
                DonationCardComponent,
                PaymentDetailsComponent,
                PaymentEditComponent,
                DonationCardDetailsComponent,
                Slide1Component,
                Slide2Component,
                Slide3Component,
                Slide4Component,
                Slide5Component,
                AddRelativeComponent,
                CommunityRequestComponent,
                PincodeComponent,
                ApproversComponent,
                PhoneInputComponent,
                OtpVerificationComponent,
                HeroesComponent,
                VersionUpdateComponent,
                MigrateCommunityComponent

        ],
        imports: [
                CommonModule,
                IonicModule,
                FormsModule,
                NgxGraphModule,
                QRCodeModule,
                ReactiveFormsModule,
                AgGridAngular,
                ImageCropperComponent

        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        exports: [
                LinebreaksPipe,
                DateShortPipe,
                FancyDateOnlyPipe,
                FancyFullDatePipe,
                SafeHtmlPipe,
                FancyYearOnlyPipe,
                FancyDatePipe,
                SortingPipe,
                FancyTimeOnlyPipe,
                TranslatePipe,
                FancyMonthYearPipe,
                SplitDateOnlyPipe,
                MiliToTimePipe,
                TwoDigitPipe,
                TwoDigitDecimalPipe,
                EncryptionPipe,
                DigitPipe,
                MiliDateTimePipe,
                MiliDateFancyPipe,
                MiliDateDiffPipe,
                InWordsPipe,
                DateComponent,
                AInputComponent,
                ATextAreaComponent,
                ASelectComponent,
                AttachmentDisplayComponent,
                SimpleDatePipe,
                AgePipe,
                PrintComponent,
                SimpleDatePipe,
                SearchComponent,
                FilterComponent,
                HeaderComponent,
                HierarchyViewComponent,
                HierarchyComponent,
                YesNoPipe,
                CircleComponent,
                NodeComponent,
                UserViewPage,
                AddressComponent,
                Swim2Component,
                AgGridAngular,
                MasterDropdownComponent,
                PaginationComponent,
                FeedComponent,
                PdCardComponent,
                MasterBoxComponent,
                CondolenceComponent,
                MarriageComponent,
                JobComponent,
                ShopComponent,
                EventComponent,
                TableHeaderComponent,
                UserMergeComponent,
                UserEditComponent,
                DateModelComponent,
                BhawanComponent,
                LoaderComponent,
                InfoComponent,
                DesignationLocationComponent,
                UserListCardComponent,
                CommitteeMemberListComponent,
                DonationListComponent,
                RuleBoxComponent,
                ElectionListPage,
                QRCodeModule,
                DonationCardComponent,
                PaymentDetailsComponent,
                PaymentEditComponent,
                DonationCardDetailsComponent,
                Slide1Component,
                Slide2Component,
                Slide3Component,
                Slide4Component,
                Slide5Component,
                AddRelativeComponent,
                CommunityRequestComponent,
                PincodeComponent,
                PhoneInputComponent,
                OtpVerificationComponent,
                ApproversComponent,
                HeroesComponent,
                VersionUpdateComponent,
                MigrateCommunityComponent

        ]
})
export class SharedModule {
}
